<template>
  <div class="filter-variation-menu">
    <div
      v-for="variation in variations"
      :key="variation.id"
      v-tooltip="{
        content: disabledTooltipText(variation),
        placement: 'bottom',
        onShow: () => !!variation.disabled,
      }"
      class="filter-variation-menu-item"
      :class="{
        'text-inactive-text': variation.disabled,
      }"
      @click.stop="setVariation(variation)"
    >
      {{ variation.label }}
    </div>
  </div>
</template>

<script setup lang="ts">
import useTranslate from '@/utilities/composables/useTranslate';

interface Variation {
  id: string;
  label: string;
  disabled?: boolean;
}

defineProps<{
  variations: Array<Variation>;
}>();

//define emits
const emit = defineEmits(['set-variation', 'close-tippy']);

const { translate } = useTranslate();

const disabledTooltipText = (variation: Variation) => {
  if (variation.disabled) {
    switch (variation.id) {
      case 'excludes':
        return translate('cannotExcludeAll');
      case 'includes':
        return translate('mustIncludeAtLeastOne');
      default:
        return '';
    }
  }
  return '';
};

// emit on click
const setVariation = (variation: Variation) => {
  if (variation.disabled) return;
  emit('set-variation', variation);
  emit('close-tippy');
};
</script>

<style lang="scss">
.filter-variation-menu {
  display: flex;
  flex-direction: column;
  max-height: 489px;
  border-radius: 8px;
  @apply bg-important-bg border border-solid border-important-border shadow-md text-text-default;
  width: auto;
  max-width: 160px;
  padding: 4px 0;
  overflow: hidden;

  .filter-variation-menu-item {
    height: 24px;
    padding: 0 16px;
    display: flex;
    align-items: center;

    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: $stPrimaryColor;
    @apply max-w-[150px]
    whitespace-nowrap
    text-ellipsis
    overflow-hidden
    text-text-default
    bg-important-bg;

    &:hover {
      @apply bg-important-hover;
    }
  }
}
</style>
